import React from 'react';

const Video = ({onClick,source, onPlay}) => {
  return (
    <video
      controlsList="noplaybackrate nodownload"
      onClick={onClick}
      controls
      onPlay={onPlay}
      className="mainpage-cardContainer-card-image"
      src={source} type="video/mp4"
      >
      <source  />
      Your browser does not support HTML5 video.
    </video>
  );
};

export default Video;
